import React from "react";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import rootReducer from "../reducers";
import PaymentOptions from "./PaymentOptions";
import axios from "axios";

// Set up the Redux store with DevTools if available
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

// Add the cart items to the store
const setCartItems = (items) => {
  return {
    type: 'SET_CART_ITEMS',
    items
  };
};

class SpecialCartCheckout extends React.Component {
  constructor(props) {
    super(props);
    
    // Initialize with the cart data
    store.dispatch(setCartItems([
      // Serum seats
      {
        id: this.props.serumSeatId,
        name: "Serum Seat",
        short_description: `${this.props.seatQuantity} Serum Seats - Special Offer`,
        price: this.props.seatPrice,
        quantity: this.props.seatQuantity,
        item_type: 'Product'
      },
      // Add Serum 2 if included
      ...(this.props.includeSerum2 ? [{
        id: this.props.serum2Id,
        name: "Serum 2",
        short_description: "Serum 2 - Special Offer",
        price: this.props.serum2Price,
        item_type: 'Product'
      }] : [])
    ]));
  }

  render() {
    return (
      <Provider store={store}>
        <PaymentOptions 
          stripeKey={this.props.stripeKey}
          paypalClientId={this.props.paypalClientId}
          userId={this.props.userId}
          specialCartToken={this.props.accessToken}
        />
      </Provider>
    );
  }
}

export default SpecialCartCheckout;